import { z } from 'zod';

export const SAddress = z
  .object({
    id: z.number(),
    full_name: z.string().nullable(),
    address_type: z.string().nullable(),
    body_address: z.string().nullable(),
    is_main_address: z.boolean(),
    type: z.number().nullable(),
    recipient_name: z.string().nullable(),
    place: z.string().nullable(),
    address: z.string().nullable(),
    phone_number: z.string().nullable(),
    rt: z.string().nullable(),
    rw: z.string().nullable(),
    kelurahan: z.string().nullable(),
    kecamatan: z.string().nullable(),
    kota_kabupaten: z.string().nullable(),
    provinsi: z.string().nullable(),
    master_kelurahan_code: z.string().nullable(),
    master_kecamatan_code: z.string().nullable(),
    master_kota_kabupaten_code: z.string().nullable(),
    master_provinsi_code: z.string().nullable(),
    zip_code: z.string().nullable(),
    longitude_position: z.coerce.number().nullable(),
    latitude_position: z.coerce.number().nullable(),
    is_active: z.boolean(),
  })
  .transform((data) => {
    const {
      address,
      rt,
      rw,
      type,
      kelurahan,
      kecamatan,
      kota_kabupaten,
      provinsi,
      zip_code,
      ...rest
    } = data;

    return {
      address,
      rt,
      type,
      rw,
      kelurahan,
      kecamatan,
      kota_kabupaten,
      provinsi,
      zip_code,
      ...rest,
    };
  });

export type TAddress = z.infer<typeof SAddress>;
